<template>
  <v-container>
    <v-autocomplete
      v-model="teamLookup.selected"
      :items="teamLookup.data"
      :loading="teamLookup.loading"
      item-value="id"
      label="Teams"
      hide-no-data
      clearable
      item-title="name"
      :search-input="search"
      @update:search="search"
      @update:model-value="onTeamSelected"
      @click:clear="clearSelections">
    </v-autocomplete>
    <CriteriaSelectionCompontent
      :year-id="yearId"
      :branch-year="branchYear"
      :team-id="teamLookup.selected"
      @snack="throwSnack"
      @clear-selection="clearSelections"></CriteriaSelectionCompontent>
  </v-container>
</template>

<script setup lang="ts">
import CriteriaSelectionCompontent from '@/components/criteria/CriteriaSelectionCompontent.vue';
import { BranchYearDTO, IPaginationDTO, PaginationDTO } from '@/dtos';
import { useSnack } from '@/helpers';
import { useBranchYearStore } from '@/stores/modules/admin';
import { SNACKSTATUS } from '@/stores/util';
import { ref, computed } from 'vue';

//import { sendMessageToDiscord } from '@/controllers/admin/discordController';
const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();
const { throwSnack } = useSnack(emit);
interface Props {
  branchId: string;
  yearId: string;
  branchYear: BranchYearDTO;
}
const props = defineProps<Props>();
const branchYearStore = useBranchYearStore();
const branchId = computed(() => props.branchId);
const yearId = computed(() => props.yearId);
const pagination = ref<IPaginationDTO>(new PaginationDTO());
const { data: branchYearData, isLoading: branchyearIsLoading } =
  branchYearStore.getBranchYearTeamsQuery(branchId, yearId, pagination);
const teamLookup = ref({
  selected: '',
  data: computed(() => branchYearData.value?.data ?? []),
  loading: computed(() => branchyearIsLoading.value),
});
const selectedTeam = ref<string>('');
const clearSelections = () => {
  teamLookup.value.selected = '';
  selectedTeam.value = '';
};

const onTeamSelected = (value: string) => {
  selectedTeam.value = value;
};

const search = async (value: string) => {
  pagination.value.q = value;
};
</script>
